export default __webpack_public_path__ + "static/property-overview-3-6df15dcdc6d1969d89f0061cf18ca92a.png";